import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { IonBadge, IonFooter, IonLabel, IonTabBar, IonTabButton } from '@ionic/angular/standalone';

import { DeviceService } from '@core/device';
import { I18nPipe } from '@core/i18n';

import { IconComponent } from '@shared/icon';

import { resolveShellNavBadges } from '../shell-nav-notifications.util';
import { ShellStore } from '../shell.store';
import { TAB_ITEMS } from './tabs.types';

@Component({
  selector: 'ml-shell-tabs',
  imports: [
    IconComponent,
    I18nPipe,
    IonBadge,
    IonFooter,
    IonLabel,
    IonTabBar,
    IonTabButton,
    RouterLink,
    RouterLinkActive,
  ],
  host: {
    class: 'ml-shell-tabs',
    '[class.platform-android]': 'device.isAndroid()',
    '[class.platform-ios]': 'device.isIos()',
  },
  templateUrl: './tabs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellTabsComponent {
  private readonly shellStore = inject(ShellStore);

  protected readonly device = inject(DeviceService);
  protected readonly items = TAB_ITEMS;

  protected readonly navBadges = computed(() =>
    resolveShellNavBadges(this.shellStore.navNotificationCounts()),
  );
}
